<template>
  <div>
    <b-row>
      <b-col>
        <b-tabs
          v-if="displayActivity || displaySettings"
          content-class="scollable-container"
          nav-wrapper-class="sticky-top bg-light"
          card
        >
          <b-tab active>
            <template #title>
              <b-spinner
                  v-if="loadingDisplay"
                  type="grow" small
              />
              <h4>Display</h4>
            </template>
            <vue-custom-scrollbar
                class="scroll-area"
                :settings="settingsScroll"
                @ps-scroll-y="scrollHandle"
            >
              <p style="margin-top: 0px">
                <base-display
                    :resource="resource"
                />
                <slot name="display" />
              </p>
            </vue-custom-scrollbar>
          </b-tab>
          <b-tab v-if="displayActivity">
            <template #title>
              <h4>Activity</h4>
            </template>
            <p class="p-3" style="margin-top: 5px">
              <b-container>
                <base-activity :resource="resource" />
                <slot name="activity"></slot>
              </b-container>
            </p>
          </b-tab>
          <b-tab v-if="displaySettings">
            <template #title>
              <h4>Settings</h4>
            </template>
            <vue-custom-scrollbar
                class="scroll-area"
                :settings="settingsScroll"
                @ps-scroll-y="scrollHandle"
            >
            <div class="p-3" style="margin-top: 5px">
              <b-container>
                Set-Up and Customize
                <base-settings
                    :resource="resource"
                    :settings="settings"
                />
                <slot name="settings" />
                <b-button
                  variant="primary btn-round-fill"
                  @click.prevent="handleUpdateSettings"
                >
                  Save Settings
                </b-button>
              </b-container>
            </div>
            </vue-custom-scrollbar>
          </b-tab>
        </b-tabs>
        <div v-else>
          <slot name="display" />
        </div>
      </b-col>
    </b-row>
    <!------ WELCOME|INTRO}ABOUT LAYER ---->
    <about-intro
        :id="aboutIntroId"
        :position="aboutIntroPos"
        :resource="resource"
        :settings="settings"
        @update-settings="handleUpdateSettings"
        @app-log="appLog"
    />
  </div>
</template>

<script>
import AboutIntro from "@/components/modals/aboutIntro";
import BaseDisplay from "./sections/baseDisplay";
import BaseActivity from "./sections/baseActivity";
import BaseSettings from "./sections/baseSettings";
import VueCustomScrollbar from 'vue-custom-scrollbar';
import "vue-custom-scrollbar/dist/vueScrollbar.css"
export default {
  name: "BaseResourceModal",
  components: {
    AboutIntro,
    BaseDisplay,
    BaseActivity,
    BaseSettings,
    VueCustomScrollbar
  },
  props: {
    loadingDisplay: {
      type: Boolean,
      default: false
    },
    isManagementMode: {
      type: Boolean,
      default: false
    },
    resource: {
      type: Object,
      default: () => {}
    },
    settings: {
      type: Object,
      default: () => {}
    },
    userData: {
      type: Object,
      default: () => {}
    },
    displayActivity: {
      type: Boolean,
      default: true
    },
    displaySettings: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    //Created and Called by Each App
    //Each app can determine if they even want an about Into
    if (!this.settings || !this.settings.hasSeenAboutIntro ){
      this.handleOpenAboutIntroClick();
    }
  },
  methods: {
    appLog(){
      //Moving logging to the state and possibly using logEvents/Firebase
    },
    handleOpenAboutIntroClick() {
      this.$bvModal.show(this.aboutIntroId);
    },
    handleUpdateSettings() {
      //can be a mixin
      this.$emit("update-settings"); //Resource Base
    },
    scrollHandle(evt) {
      console.log(evt);
    }
  },
  data() {
    return {
      settingsScroll: {
        suppressScrollY: false,
        suppressScrollX: true,
        wheelPropagation: false
      },
      aboutIntroId: "about-intro",
      aboutIntroPos: 1,
    };
  },
};
</script>

<style lang="scss" scoped>
.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 90vh;
}
</style>
